module.exports = __webpack_public_path__ + "static/media/COS_DIELEN.5949cb6f.png";